import pRetry from 'p-retry'

async function fetchWithRetryInternal(
  doRetry: boolean,
  input: Parameters<typeof fetch>[0],
  init?: Parameters<typeof fetch>[1]
): ReturnType<typeof fetch> {
  const queryFn = () => fetch(input, init)

  try {
    return await (!doRetry
      ? queryFn()
      : pRetry(queryFn, {
          onFailedAttempt: ({ attemptNumber, retriesLeft }) => {
            console.warn(`Attempt ${attemptNumber} failed. There are ${retriesLeft} retries left.`)
          },
          retries: 3
        }))
  } catch (error: unknown) {
    const url = extractUrl(input)
    const method = init ? init.method : 'GET'
    throw new Error(`Problem fetching ${doRetry ? 'with' : 'without'} retry, URL: '${url}' with method '${method}'`, {
      cause: error
    })
  }
}

function extractUrl(input: Parameters<typeof fetch>[0]): string {
  if (typeof input === 'string') return input
  if (input instanceof URL) return input.href
  if (typeof Request !== 'undefined' && input instanceof Request) return input.url
  return String(input)
}

export async function fetchWithRetry(
  input: Parameters<typeof fetch>[0],
  init?: Parameters<typeof fetch>[1]
): ReturnType<typeof fetch> {
  return fetchWithRetryInternal(true, input, init)
}
